module.exports = __webpack_public_path__ + "img/1.bab98a30.png";